import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const [storedToken, setStoredToken] = useState(() => localStorage.getItem('authToken'));

  useEffect(() => {
    const handleStorage = () => {
      setStoredToken(localStorage.getItem('authToken'));
    };
    const handleFocus = () => {
      setStoredToken(localStorage.getItem('authToken'));
    };
    const handleAuthChange = () => {
      setStoredToken(localStorage.getItem('authToken'));
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('authchange', handleAuthChange);

    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('authchange', handleAuthChange);
    };
  }, []);

  if (!storedToken) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;